<template>
  <v-dialog
    :modelValue="dialog"
    @click:outside="$emit('updateDialog')"
    @keydown.esc="$emit('updateDialog')"
    :max-width="$vuetify.display.mdAndDown ? undefined : '750px'"
    :scrim="!$vuetify.display.mdAndDown"
    :fullscreen="$vuetify.display.mdAndDown"
  >
    <v-card
      :class="$vuetify.display.mdAndDown ? 'h-100 d-flex flex-column' : ''"
    >
      <v-card-title class="title-modal">
        <span class="headline">DETALLE ASN</span>
      </v-card-title>

      <v-card-text
        :class="$vuetify.display.mdAndDown ? 'flex-grow-1 overflow-auto' : ''"
      >
        <v-container fluid class="mt-0 mb-0">
          <v-row justify="center">
            <v-col :cols="$vuetify.display.smAndDown ? 12 : 12">
              <v-form ref="form">
                <v-combobox
                  v-model="item.product"
                  name="product"
                  item-title="label"
                  item-value="id"
                  :items="products"
                  label="Producto*"
                  autocomplete="off"
                  :rules="[rules.requiredComboBox]"
                  clearable
                  @update:modelValue="onProductChange"
                >
                  <!-- Los incompletos se pueden avisar en el ASN, pero el administrativo tiene
                       que ver cuales son: al recibirlos el operario va a tener que cargarles
                       las presentaciones desde el mobile. -->
                  <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props" :title="item.raw.label">
                      <template v-slot:append v-if="isIncompleteProduct(item.raw)">
                        <v-chip color="orange" size="x-small">Incompleto</v-chip>
                      </template>
                    </v-list-item>
                  </template>
                </v-combobox>

                <!-- validar numerico  -->
                <v-text-field
                  autocomplete="off"
                  name="expected_amount"
                  label="Cantidad Esperada*"
                  type="text"
                  v-model="item.expected_amount"
                  :rules="[rules.required]"
                />

                <div v-if="requestAttributes && item.product">
                  <p class="text-caption text-grey-600 mb-2">Atributos esperados (opcional)</p>

                  <v-text-field
                    v-if="item.product.tiene_control_por_lotes"
                    autocomplete="off"
                    name="expected_lote"
                    label="Lote"
                    type="text"
                    v-model="item.expected_lote"
                  />

                  <v-text-field
                    v-if="item.product.requiere_fecha_expiracion"
                    name="expected_expiration_date"
                    label="Fecha de Expiración"
                    type="date"
                    v-model="item.expected_expiration_date"
                  />

                  <div v-if="item.product.tiene_control_por_serie">
                    <v-btn
                      color="blue-darken-2"
                      dark
                      class="mb-4"
                      @click="addSerie()"
                      :disabled="series_arr.length === parseInt(item.expected_amount)"
                      size="small"
                    >
                      <v-icon left>mdi-plus</v-icon> AGREGAR SERIE
                    </v-btn>

                    <v-data-table
                      :headers="header_serie"
                      :items="series_arr"
                      class="elevation-1 mb-4"
                      no-data-text="No hay datos disponibles"
                      hide-default-footer
                    >
                      <template v-slot:item="{ index }">
                        <tr>
                          <td>
                            <v-text-field
                              v-model="series_arr[index].serie"
                              placeholder="Ingrese serie"
                              variant="underlined"
                              :error-messages="series_arr[index].errorMessage"
                              class="custom-text-field-table"
                              @change="validateSerie(index)"
                            ></v-text-field>
                          </td>

                          <td class="text-center" style="width: 110px">
                            <v-icon v-on:click="deleteSerie(index)" color="red" class="mr-2" small>mdi-delete</v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>

                  <v-autocomplete
                    v-if="item.product.tiene_control_de_calidad"
                    v-model="item.expected_quality"
                    name="expected_quality"
                    item-title="name"
                    item-value="id"
                    :items="qualities"
                    label="Calidad"
                    autocomplete="off"
                    return-object
                    clearable
                  ></v-autocomplete>

                  <template v-for="key in descriptiveKeys" :key="key">
                    <v-text-field
                      v-if="isAliasEnabled(key) && item.product['tiene_control_por_' + key]"
                      autocomplete="off"
                      :name="key"
                      :label="getAliasName(key)"
                      type="text"
                      v-model="item[key]"
                    />
                  </template>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions
        class="pa-4"
        :class="$vuetify.display.mdAndDown ? 'flex-shrink-0' : ''"
      >
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          :variant="'text'"
          @click="$emit('updateDialog')"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green"
          :variant="'text'"
          @click="addNewProduct()"
          :class="$vuetify.display.mdAndDown ? 'px-6 ml-3' : ''"
        >
          {{ itemEdit != null ? "Editar" : "Agregar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { productoService } from "@/libs/ws/productoService";
import { productQualityService } from "@/libs/ws/productQualityService";
import ValidMixin from "@/mixins/ValidMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";

export default {
  created() {},
  mixins: [ValidMixin, AliasMixin],
  components: {},
  props: {
    dialog: Boolean,
    asn: Object,
    updateDialog: Function,
    addProduct: Function,
    itemEdit: Object,
    requestAttributes: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    item: {
      lpn: "",
      product: null,
      expected_amount: null,
      expected_manufacture_date: null,
      expected_expiration_date: null,
      expected_lote: null,
      expected_serie: null,
      expected_quality: null,
      expected_storage_units_amount: null,
      descriptivo_1: null,
      descriptivo_2: null,
      descriptivo_3: null,
      external_line_number: "",
    },
    descriptiveKeys: ["descriptivo_1", "descriptivo_2", "descriptivo_3"],
    defaultItem: null,
    presentation_products: [],
    products: [],
    qualities: [],
    header_serie: [
      { title: "Serie", key: "serie", sortable: false },
      { title: "Accion", sortable: false },
    ],
    series_arr: [],
  }),
  watch: {
    dialog() {
      if (this.itemEdit == null) {
        this.item = JSON.parse(JSON.stringify(this.defaultItem));
        this.series_arr = [];
      } else {
        this.item = JSON.parse(JSON.stringify(this.itemEdit));
        // Una linea con serie es una sola serie: al editar la tabla arranca con esa
        this.series_arr = this.item.expected_serie ? [{ serie: this.item.expected_serie, errorMessage: "" }] : [];
        if (this.requestAttributes) this.loadQualities();
      }
    },
  },
  mounted() {
    this.loadProducts();
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    loadProducts() {
      let client = this.asn.client != null ? this.asn.client.id : null;
      // list_minify: query liviano (sin N+1 ni serializacion completa). Con
      // detailed:true trae las flags de control, necesarias para los atributos esperados.
      // include_incomplete: un ASN puede avisar productos que todavia no tienen presentaciones;
      // el operario se las carga al recibirlos.
      productoService.list_minify({ client: client, detailed: this.requestAttributes, include_incomplete: true }).then((response) => {
        this.products = response.result.list;
      });
    },
    isIncompleteProduct(product) {
      return product != null && product.status === productoService.PRODUCT_COMPLETITUD_INCOMPLETO;
    },
    onProductChange() {
      this.clearUncontrolledAttributes();
      this.loadQualities();
    },
    // Evita arrastrar atributos de un producto anterior que el nuevo no controla
    clearUncontrolledAttributes() {
      const product = this.item.product != null && typeof this.item.product === "object" ? this.item.product : {};
      if (!product.tiene_control_por_lotes) this.item.expected_lote = null;
      if (!product.requiere_fecha_expiracion) this.item.expected_expiration_date = null;
      if (!product.tiene_control_por_serie) {
        this.item.expected_serie = null;
        this.series_arr = [];
      }
      if (!product.tiene_control_de_calidad) this.item.expected_quality = null;
      this.descriptiveKeys.forEach((key) => {
        if (!product["tiene_control_por_" + key]) this.item[key] = null;
      });
    },
    loadQualities() {
      if (this.item.product == null) {
        return;
      }

      productQualityService
        .filter({ product: this.item.product.id })
        .then((response) => {
          this.qualities = response.result.list;
        });
    },
    // Misma logica que ModalRecepcion: se cargan las series a mano, sin repetir y sin vacias,
    // hasta completar la cantidad esperada.
    validateSerie(index) {
      const serieIngresada = this.series_arr[index].serie.trim();

      if (!serieIngresada) {
        this.series_arr[index].errorMessage = "La serie no puede estar vacía.";
        return;
      }

      const existe = this.series_arr.some((item, i) => i !== index && item.serie === serieIngresada);

      if (existe) {
        this.series_arr[index].errorMessage = "La serie ya ha sido ingresada.";
        this.series_arr[index].serie = "";
      } else {
        this.series_arr[index].errorMessage = "";
      }
    },
    addSerie() {
      this.series_arr.push({ serie: "", errorMessage: "" });
    },
    deleteSerie(index) {
      this.series_arr = this.series_arr.filter((_, i) => i !== index);
    },
    seriesControl() {
      return this.requestAttributes && this.item.product != null && this.item.product.tiene_control_por_serie;
    },
    validateSeries() {
      if (this.series_arr.some((item) => item.serie == null || item.serie.trim() === "")) {
        this.toast.error("Hay series sin completar.");
        return false;
      }

      if (this.series_arr.length > parseInt(this.item.expected_amount)) {
        this.toast.error("No se pueden ingresar mas series que la cantidad esperada.");
        return false;
      }

      return true;
    },
    async addNewProduct() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;

      if (!this.seriesControl()) {
        this.$emit("addProduct", this.item);
        return;
      }

      if (!this.validateSeries()) return;

      // Cada serie es una linea del ASN de 1 unidad: expected_serie es uno solo por linea
      const items = this.series_arr.map((serie_data) => {
        const line = JSON.parse(JSON.stringify(this.item));
        line.expected_serie = serie_data.serie.trim();
        line.expected_amount = 1;
        return line;
      });

      // Lo que no se informo queda en una linea con la serie a definir al recibir
      const pendientes = parseInt(this.item.expected_amount) - this.series_arr.length;
      if (pendientes > 0) {
        const line = JSON.parse(JSON.stringify(this.item));
        line.expected_serie = null;
        line.expected_amount = pendientes;
        items.push(line);
      }

      this.$emit("addProduct", items);
    },
  },
};
</script>
